export const ASYNC_FETCH = 'ILD_Landing/ASYNC_FETCH';
export const ASYNC_FETCH_ILDLANDING_SUCCESS = 'ILD_Landing/ASYNC_FETCH_ILDLANDING_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ILD_Landing/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ILD_Landing/ASYNC_FETCH_INVALIDATE';
export const ASYNC_FETCH_ILDLANDINGCQ_SUCCESS='ILD_Landing/ASYNC_FETCH_ILDLANDINGCQ_SUCCESS';
/**
 * action types
 * @type {string}
 */
export const formatPhoneNumber = (val) => { // eslint-disable-line
  if (val !== '') {
    return val.substring(0, 3) + '.' + val.substring(3, 6) + '.' + val.substring(6);
  }
  return val;
};
